// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EVX1","top":"styles_top__2okv0"};